import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { AddTransactionForm } from '~/components/portfolio/add-transaction-form.tsx';
import { getPortfolioPageDataQueryOptions } from '~/server/portfolio/portfolio-page-data-query.ts';

export const Route = createFileRoute('/portfolios/$portfolioId/transaction')({
	component: PortfolioAddTransactionPage,
});

function PortfolioAddTransactionPage() {
	const { portfolioId } = Route.useParams();
	const { data: loaderData } = useSuspenseQuery(getPortfolioPageDataQueryOptions({ portfolioId: Number(portfolioId) }));
	const portfolio = loaderData.activePortfolio;

	if (!portfolio) {
		return null;
	}

	return <AddTransactionForm portfolioId={portfolio.id} userLocale={loaderData.userLocale} />;
}
